import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=6cdd27af&scoped=true&"
import script from "./Tickets.vue?vue&type=script&lang=tsx&"
export * from "./Tickets.vue?vue&type=script&lang=tsx&"
import style0 from "./Tickets.vue?vue&type=style&index=0&id=6cdd27af&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdd27af",
  null
  
)

export default component.exports